module.exports = __webpack_public_path__ + "static/media/img27-2.2c4f3dde.jpg";